import type { AxiosInstance } from "axios";
import { internalApiClient } from "@/marketing/infrastructure/http/httpClient";
import type {
  Brand,
  BrandFilter,
  CreateBrandRequest,
  UpdateBrandRequest,
} from "@/marketing/models/brand";

const BASE_PATH = "/brand";

export class BrandAPIClient {
  constructor(private readonly client: AxiosInstance = internalApiClient) {}

  public async listBrands(filter: BrandFilter = {}): Promise<Brand[]> {
    const { data } = await this.client.get<Brand[]>(BASE_PATH, {
      params: filter,
    });
    return data;
  }

  public async getBrand(brandId: string): Promise<Brand> {
    const { data } = await this.client.get<Brand>(`${BASE_PATH}/${brandId}`);
    return data;
  }

  public async createBrand(request: CreateBrandRequest): Promise<Brand> {
    const { data } = await this.client.post<Brand>(BASE_PATH, request);
    return data;
  }

  public async updateBrand(
    brandId: string,
    request: UpdateBrandRequest,
  ): Promise<void> {
    await this.client.patch<void>(`${BASE_PATH}/${brandId}`, request);
  }

  public async deleteBrand(brandId: string): Promise<void> {
    await this.client.delete<void>(`${BASE_PATH}/${brandId}`);
  }
}

export const brandAPIClient = new BrandAPIClient();
